import { render, staticRenderFns } from "./Browse.EmailList.vue?vue&type=template&id=78b9c52d&scoped=true&"
import script from "./Browse.EmailList.vue?vue&type=script&lang=js&"
export * from "./Browse.EmailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b9c52d",
  null
  
)

export default component.exports